module.exports = __webpack_public_path__ + "static/img/zi-bg.fee303e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/images/zi-bg.png
// module id = NBk1
// module chunks = 4